export interface Language {
  key: string;
  beta?: boolean; // if in beta, will be visually differentiated in the UI
}
export const languages: Language[] = [
  { key: "de" },
  { key: "en" },
  { key: "es" },
  { key: "fr" },
  { key: "it" },
  { key: "pl" },
];
